<div class="modal-header text-center">
  <h4 class="mb-0">Are you sure?</h4>
</div>
<div
  class="modal-body"
>
  <p [innerHTML]="deletionMessage"></p>
  <div>
    <label>If you are sure, type “REMOVE” below:</label>
    <input
      pInputText
      type="text"
      class="form-control mt-2"
      [placeholder]="passwordToDelete"
      [(ngModel)]="typingConfirmation"
    />
  </div>
</div>
<div class="modal-footer">
  <div class="btn btn-default pull-left" aria-label="Cancel" (click)="cancel()">
    Cancel
  </div>
  <button
    [disabled]="passwordToDelete !== typingConfirmation"
    class="btn btn-danger pull-right"
    aria-label="Confirm"
    (click)="confirm()"
  >
    Remove
  </button>
</div>
